import api from '@/services/api';

export interface SessionLogUpload {
  uploadId: string;
  provider: string;
  fileName: string;
  sizeBytes: number;
  status: 'pending' | 'uploaded';
  createdBy: string;
  createdAtUnixMs: number;
  uploadedAtUnixMs: number;
}

export interface ListSessionLogsReply {
  uploads: SessionLogUpload[];
  providers: string[];
  nextCursor: string;
}

export interface PreviewSessionLogReply {
  uploadId: string;
  contentBase64: string;
  nextCursor: string;
  hasMore: boolean;
}

const base = '/api/v1/session-log-uploads';

export const sessionLogsApi = {
  list: (
    params: { provider?: string; pageSize: number; cursor?: string },
    signal?: AbortSignal,
  ) => api.get<never, ListSessionLogsReply>(base, { params, signal }),
  preview: (uploadId: string, cursor?: string, signal?: AbortSignal) =>
    api.get<never, PreviewSessionLogReply>(
      `${base}/${encodeURIComponent(uploadId)}/preview`,
      { params: { cursor }, signal },
    ),
};
